import { render, staticRenderFns } from "./Reconnecting.vue?vue&type=template&id=2c3b5ff4&scoped=true"
import script from "./Reconnecting.vue?vue&type=script&lang=js"
export * from "./Reconnecting.vue?vue&type=script&lang=js"
import style0 from "./Reconnecting.vue?vue&type=style&index=0&id=2c3b5ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b5ff4",
  null
  
)

export default component.exports